module.exports = __webpack_public_path__ + "images/a6808b8fb76a2146230b10e7edc48a62-logo_hungarian.png";